import { TransactionType } from "../../../views/Orders/enums";
import { EnrichedSupplierForDelivery } from "../types";

export function isFacilitationTransactionType(
  transactionType?: string | null,
): boolean {
  return transactionType === TransactionType.FACILITATION;
}

export function hasSupplierSplitWithFacilitation(
  suppliers: EnrichedSupplierForDelivery[],
): boolean {
  return suppliers.some(
    (supplier) =>
      supplier.supplierId != null &&
      isFacilitationTransactionType(supplier.transactionType),
  );
}

export function isSupplierSplitValidForSingleInvoice(
  supplier: EnrichedSupplierForDelivery,
  isSingleInvoiceEnabled: boolean,
): boolean {
  if (!isSingleInvoiceEnabled || supplier.supplierId == null) {
    return true;
  }
  return !isFacilitationTransactionType(supplier.transactionType);
}
